import { Auth } from 'aws-amplify';
import { ROLES } from "../_constants/roles";

export default async function postLogin() {
    const APP_ROLES = [ROLES.ADMIN, ROLES.JUDGE];
    return Auth.currentSession()
        .then(session => {           
            const accessToken = session.getAccessToken().getJwtToken();
            const idToken = session.getIdToken();
            const jwt = idToken.jwtToken;
            const payload = session.getIdToken().decodePayload();
            const lookUpKey = payload.email;

            const rawGroups = Array.isArray(payload['cognito:groups'])
                ? payload['cognito:groups']
                : [];

            const roles = rawGroups
                .filter(g=> APP_ROLES.includes(g));
                
            const user = {
                id: payload.sub,
                roles: roles,
                userName: payload.email,
                token: accessToken
            }

            return user;

        }).catch(err => {
            console.error("postLogin error", err);
            throw err
        });
}